<template>
  <b-modal @change="change" :visible="visible" hide-footer hide-header centered>
    <div class="confirmation p-2">
      <div class="embed-responsive embed-responsive-16by9">
        <iframe
          :src="src"
          class="embed-responsive-item"
          allowfullscreen
          allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
          loading="lazy"
        >
        </iframe>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      default: "Tem certeza?"
    },
    src: {
      type: String,
      default: ""
    }
  },
  model: {
    prop: "visible",
    event: "change"
  },
  methods: {
    change(val) {
      this.$emit("change", val);
    },
    cancel() {
      this.$emit("cancel");
      this.change(false);
    },
    confirm() {
      this.$emit("confirm");
      this.change(false);
    }
  }
};
</script>

<style lang="scss">
.confirmation {
  h3 {
    font-weight: bold;
    font-size: 18px;
    line-height: 22px;
  }

  .text {
    font-size: 14px;
    line-height: 17px;
  }
}
</style>
